import React, { useState, useEffect } from 'react';
import * as generic from './generic.js';
import Loader from './Loader.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons'

import FaseSelect from './FaseSelect.js';
import Chaves from './Chaves.js';
import Classificacao from './Classificacao.js';
import Clube from './Clube.js';

import imgSrgoool from './assets/srgoool.svg';

import {InlineShareButtons} from 'sharethis-reactjs';

function GoTo(props) {
	window.document.location = props.href;
	return null;
}

function Modal(props) {
	return <>
		<div className="blackout" onClick={(e) => props.onClose()}></div>
		<div className="modal-wrapper" onClick={(e) => props.onClose()}>
			<div className="modal">
				<div>{props.text}</div>
				{props.children}
				<div className="button-line"><button>Fechar</button></div>
			</div>
		</div>
	</>;
}

function ModalShare(props) {
	let text = "Veja a minha simulação no SrGoool: " + props.shareLink;
	let title = "Simulação no SrGoool";


	console.log(title, text);

	return <>
		<div className="blackout" onClick={(e) => props.onClose()}></div>
		<div className="modal-wrapper" onClick={(e) => props.onClose()}>
			<div className="modal">
				<div>
				    <InlineShareButtons
					  config={{
					    alignment: 'center',  // alignment of buttons (left, center, right)
					    color: 'white',      // set the color of buttons (social, white)
					    enabled: true,        // show/hide buttons (true, false)
					    font_size: 14,        // font size for the buttons
					    labels: 'null',        // button labels (cta, counts, null)
					    language: 'pt',       // which language to use (see LANGUAGES)
					    networks: [           // which networks to include (see SHARING NETWORKS)
					      'whatsapp',
					      'telegram',
					      'instagram',
					      'linkedin',
					      'messenger',
					      'facebook',
					      'twitter',
					      'email'
					    ],
					    padding: 5,          // padding within buttons (INTEGER)
					    radius: 5,            // the corner radius on each button (INTEGER)
					    show_total: false,
					    size: 30,             // the size of each button (INTEGER)

					    // OPTIONAL PARAMETERS
					    //image: (state.result?.share_img ? "/img.php?id_imagem=" + state.result?.share_img : "/img/logo_portal_eventos.png"),  // (defaults to og:image or twitter:image)
					    url: props.shareLink,
					    description: text,
					    title: title,
					    message: text,
					    subject: title,
					    //username: 'custom twitter handle' // (only for twitter sharing)
					  }}
					/>
				</div>
				<div className="button-line"><button>Fechar</button></div>
			</div>
		</div>
	</>;
}

function ClubeSelect(props) {
	const [ state, setState ] = useState(false);
	const [ search, setSearch ] = useState("");
	const toggleOpen = () => {
		setState((state) => !state);
	};

	let searchDiv = null;

	if (state) {
		const searchText = search.toLowerCase();
		searchDiv = <>
			<div className="blackout" onClick={(e) => toggleOpen()}></div>
			<div className="popup-wrapper">
				<div className="popup">
					<input placeholder="Pesquisar" value={search} onChange={(e) => { setSearch(e.target.value); }}/>
					{Object.values(props.clubeMap).filter(clube => (
						clube.name.toLowerCase().indexOf(searchText) >= 0 || clube.name_short.toLowerCase().indexOf(searchText) >= 0
					)).filter(clube => (
						clube.id != props.exclude
					)). sort((a,b) => a.name.localeCompare(b.name)).map((clube) => {
						let style = {};
						if (props.saiu.indexOf(clube.id) >= 0) {
							style.filter = "grayscale(1)";
							style.opacity = "0.5";
						}
						return <div style={style}>
							<Clube onClick={() => {
								props.onChange(clube.id);
								toggleOpen();
								setSearch("");
							}} key={clube.id} clubeMap={props.clubeMap} clube={clube.id} className="e100 ellipsis" />
						</div>
					})}
				</div>
			</div>
		</>;
	}
	let message = null;
	if (props.saiu.indexOf(props.clube) >= 0) {
		message = <Modal
			text={"A Clube \"" + props.clubeMap[props.clube].name + "\" não pode ser selecionada devido a outras duas seleções estarem em primeiro e segundo lugar no grupo."}
			onClose={() => props.onChange(null)}
		/>
	}
	return <>
		{searchDiv}
		<div onClick={toggleOpen} className="select">
			<Clube clubeMap={props.clubeMap} clube={props.clube} className="e100 ellipsis" />
			{props.clube > 0 ? <div onClick={(e) => { props.onChange(null); e.stopPropagation(); return false; } }><FontAwesomeIcon icon={fa.faTimes}/></div> : <div><FontAwesomeIcon icon={fa.faChevronDown}/></div>}
		</div>
		{message}
	</>;
}

export default function Campeonato(props) {
	const [isLoaded, setIsLoaded] = useState(false);
	const [rightPanelOpen, setRightPanelOpen] = useState(false);

	const [faseList, setFaseList] = useState([]);
	const [clubeMap, setClubeMap] = useState({});
	const [campeonatoInfo, setCampeonatoInfo] = useState({});

	const [campeao, setCampeao] = useState(null);
	const [vicecampeao, setVicecampeao] = useState(null);

	const [simulados, setSimulados] = useState({});
	const [geracao, setGeracao] = useState(0);

	const [primeira_posicao, setPrimeiraPosicao] = useState({});
	const [segunda_posicao, setSegundaPosicao] = useState({});
	const [showAllSimulados, setShowAllSimulados] = useState(false);
	const [clubeSaiuNosGrupos, setClubeSaiuNosGrupos] = useState([]);
	const [help, setHelp] = useState(false);
	const [error, setError] = useState(null);
	const [showShare, setShowShare] = useState(false);

	const subUrl = (props.subUrl || "").split("/");
	const shareBaseUrl = window.document.location.origin + window.document.location.pathname + "#///" + subUrl[0];
	const [shareLink, setShareLink] = useState(shareBaseUrl);

	useEffect(() => {
		setIsLoaded(false);
		generic.callserver(
			[
				{ url: "campeonato/" + props.campeonato, params: {} },
				{ url: "campeonato/" + props.campeonato + "/fase", params: {} },
				{ url: "campeonato/" + props.campeonato + "/clube", params: {} },
			],
			(result) => {
				setIsLoaded(false);
				setFaseList(result[1].result);
				let clubeMap = {};
				result[2].result.forEach(clube => { clubeMap[clube.id] = clube; });
				setClubeMap(clubeMap);
				setCampeonatoInfo(result[0].result);
				setIsLoaded(true);
			},
			(error) => {
				setError(error);
			}
		);
	}, [props.campeonato]);

	const faseListTabela = faseList.filter(element => element.exibe_tabela > 0);
	const faseListClassificacao = faseList.filter(element => element.exibe_classificacao > 0);
	const faseListArtilharia = faseList.filter(element => element.exibe_artilharia > 0);

	const updateSimulado = function(id, type, value, type2, value2) {
		const oldSimulado = simulados[id] || { "id": id };
		let newSimulado = { ...oldSimulado };
		newSimulado[type] = value;
		if (type2) {
			newSimulado[type2] = value2;
		}
		console.log("newSimulado", newSimulado, value, value2);
		setCampeao(null);
		setVicecampeao(null);
		setSimulados({ ...simulados, [id]: newSimulado });
	};

	const updateGrupoVencedor = function(type, id_grupo, id_clube) {
		setShowAllSimulados(false);
		if (type === 1) {
			if (segunda_posicao[id_grupo] === id_clube) {
				delete segunda_posicao[id_grupo];
			};
			primeira_posicao[id_grupo] = id_clube;
			setPrimeiraPosicao({ ...primeira_posicao });

		} else if (type === 2) {
			segunda_posicao[id_grupo] = id_clube;
			if (primeira_posicao[id_grupo] === id_clube) {
				delete primeira_posicao[id_grupo];
			};
			setSegundaPosicao({ ...segunda_posicao });
		}

		const url = "campeonato/" + props.campeonato + "/chaves";
		const params = { primeira_posicao: primeira_posicao, segunda_posicao: segunda_posicao };
		generic.callserverSingle(url, params, function(data) {
			let clubeSaiuNosGrupos = [];
			for (let id_grupo in primeira_posicao) {
				if (segunda_posicao[id_grupo] > 0) {
					data.classificacao.list.forEach((jogo) => {
						if (jogo.id_grupo === id_grupo && jogo.posicao > 2) {
							clubeSaiuNosGrupos.push(jogo.id_clube);
						}
					})
				}
			}
			setSimulados({ ...data.simulados });
			setClubeSaiuNosGrupos(clubeSaiuNosGrupos);
		});
	};

	const setCampeoes = function(campeao, vicecampeao) {
		const url = "campeonato/" + props.campeonato + "/chaves";
		const params = { campeao: campeao, vicecampeao: vicecampeao, simulados: {}, primeira_posicao: primeira_posicao, segunda_posicao: segunda_posicao };
		generic.callserverSingle(url, params, function(data) {
			if (data.error) {
				setError(data.error);
			} else {
				setShowAllSimulados(true);
				setPrimeiraPosicao({ ...data.classificacao.primeira_posicao });
				setSegundaPosicao({ ...data.classificacao.segunda_posicao });
				setSimulados({ ...data.simulados });
				setCampeao(data.classificacao?.campeao);
				setVicecampeao(data.classificacao?.vicecampeao);

				if (data.share) {
					const url = shareBaseUrl + "/s=" + data.share;
					setShareLink(url);

					console.log("SHARE", url);
				}
			}
		});
	};

	const resetar = function() {
		setSimulados({ simulados: {} });
		setPrimeiraPosicao({});
		setSegundaPosicao({});
		setCampeao(null);
		setVicecampeao(null);
		setClubeSaiuNosGrupos([]);

		const url = shareBaseUrl;
		setShareLink(url);

		console.log("SHARE", url);
	}

	useEffect(() => {
		if (/s=/.test(subUrl[1])) {
			const url = "campeonato/" + props.campeonato + "/chaves";
			const params = { share: subUrl[1].substr(2) };
			generic.callserverSingle(url, params, function(data) {
				if (data.error) {
					setError(data.error);
				} else {
					setShowAllSimulados(true);
					setPrimeiraPosicao({ ...data.classificacao.primeira_posicao });
					setSegundaPosicao({ ...data.classificacao.segunda_posicao });
					setSimulados({ ...data.simulados });
					setCampeao(data.classificacao?.campeao);
					setVicecampeao(data.classificacao?.vicecampeao);
				}
			});
		}
	}, [1]);

	if (!isLoaded) {
		return <Loader text="Campeonato"/>;
	} else {
		let message = null;
		if (help) {
			message = <Modal onClose={() => setHelp(false)}>
				<div>
					<b>Opções para simular:</b>

					<ol>
						<li>Aperte o botão 'simular';</li>
						<li>Escolha o campeão no select e aperte 'simular';</li>
						<li>Escolha o vice-campeão no select e aperte 'simular';</li>
						<li>Escolha o campeão e o vice no select e aperte 'simular';</li>
						<li>Escolha o 1º e o 2º colocado de todos os grupos e aperte 'simular';</li>
						<li>Escolha o 1º e/ou o 2º colocado apenas de alguns grupos e aperte 'simular';</li>
						<li>Escolha o 1º e/ou o 2º colocado de alguns grupos, o campeão no select e aperte 'simular';</li>
						<li>Escolha o 1º e/ou o 2º colocado de alguns grupos, o vice-campeão no select e aperte 'simular';</li>
						<li>Escolha o 1º e/ou o 2º colocado de alguns grupos, o campeão e o vice no select e aperte 'simular';</li>
					</ol>
					<br/>
					<b>O simulador automático do Sr. Goool ainda tem outros botões para facilitar a simulação como o 'resetar' (apaga a simulação), o 'compartilhar' (para enviar o simulador aos amigos ou divulgar nas redes sociais) e 'reportar erro' (caso tenha algum problema na ferramenta)</b>
				</div>
			</Modal>
		} else if (error) {
			message = <Modal
				text={error}
				onClose={() => setError(null)}
			/>
		} else if (showShare) {
			console.log(showShare, shareLink);
			message = <ModalShare
				shareLink={shareLink}
				onClose={() => setShowShare(false)}
			/>
		}

		return (
			<>
				<div className="jogo row campeao-row">
					<div className="logos">
						<img src={imgSrgoool} onClick={() => window.open("https://www.srgoool.com.br/copadomundo") }/>
					</div>
					<div className="e20 dropdown">
						<div>Campeão</div>
						<ClubeSelect saiu={clubeSaiuNosGrupos} exclude={vicecampeao} onChange={(value) => setCampeao(value)} clubeMap={clubeMap} clube={campeao} className="e100 ellipsis" />
					</div>
					<div className="e20 dropdown">
						<div>Vice-campeão</div>
						<ClubeSelect saiu={clubeSaiuNosGrupos} exclude={campeao} onChange={(value) => setVicecampeao(value)} clubeMap={clubeMap} clube={vicecampeao} className="e100 ellipsis" />
					</div>
					<div className="e0ext" style={{alignSelf: "end"}}>
						<button className="e0 submit" onClick={() => setCampeoes(campeao, vicecampeao)}>
							Simular
						</button>
						<button className="e0 submit" onClick={() => resetar()}>
							Resetar
						</button>
						<button className="e0 submit" onClick={() => {
							if (shareLink) {
								console.log("Try to share: ", shareLink);
								if (window.navigator && window.navigator.share) {
									navigator.share({
										title: 'SrGoool Simulação',
										url: shareLink
									})
								} else {
									setShowShare(true);
								}
							}
						}}>
							<FontAwesomeIcon icon={fa.faShareAlt}/>
						</button>
						<button className="e0 submit help" onClick={() => {
							setHelp(true);
						}}>
							<FontAwesomeIcon icon={fa.faInfo}/>
						</button>
					</div>
				</div>
				{faseListClassificacao.length > 0 ?
					<FaseSelect faseList={faseListClassificacao} startFase={campeonatoInfo.last_fase_classificacao} render={({fase}) => (
						<>
						<div className="chave-container">
							<Classificacao
								key={"camp-" + props.campeonato}
								clubeMap={clubeMap}
								simulados={simulados}
								ignore_publico={true}
								campeonato={props.campeonato}
								fase={fase}
								rodada={fase.max_rodada}
								footnote="Classificação simulada"
								updateGrupoVencedor={updateGrupoVencedor}
								primeira_posicao={primeira_posicao}
								segunda_posicao={segunda_posicao}
								/>
							<Chaves
								editable={true}
								simulados={simulados}
								onUpdateSimulado={updateSimulado}
								clubeMap={clubeMap}
								key={"chave-" + props.campeonato}
								campeonato={props.campeonato}
								primeira_posicao={primeira_posicao}
								segunda_posicao={segunda_posicao}
								showAllSimulados={showAllSimulados}
							/>
						</div>
						</>
					)}/>
				:
					null
				}
				{message}
			</>
		);
	}
}
